import React from "react";
import {
  Alert,
  Card,
  Col,
  Row,
  Table,
  Badge,
  Image,
  Button,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";

import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ReactFancyBox from "react-fancybox";
import parse from "html-react-parser";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import {
  getCurrencyCode,
  getFullName,
} from "../../../../../helpers/CommonHelper";
import orderPending from "../../../../../images/file.png";
import orderCancel from "../../../../../images/cancelOrder.png";
import orderCompleted from "../../../../../images/delivery.png";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import { BsCheckCircleFill } from "react-icons/bs";
const Details = ({
  item,
  moduleConfig,
  confirmAndDelete,
  confirmAndBlock,
  confirmAndUnblock,
  customButtonsForItems,
}) => {
  const COLORS = {
    primary: "#455A23", // Deep forest green
    secondary: "#30160E", // Rich brown
    tertiary: "#CC9965", // Warm beige
    quaternary: "#A0AE3F", // Light sage
    yellow: "#ffed00", // Bright yellow
    orange: "#D06F36", // Burnt orange
    green: "#295B24", // Forest green
    gray: "#CFD4CD", // Soft gray
    lightGray: "#fffaf5ff", // Very light gray
    bg: "#ffffff", // White background
    text: "#2A1008", // Dark text
  };
  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing">
                  <div className="position-relative ms-1 me-2">
                    <div className="ms-1 me-2">
                      {item.orderStatus === "0" ? (
                        <img src={orderPending} className="orderImage" />
                      ) : item.orderStatus === "2" ? (
                        <img src={orderCancel} className="orderImage" />
                      ) : (
                        <img src={orderCompleted} className="orderImage" />
                      )}
                    </div>
                  </div>

                  <div className="d-flex flex-column  ms-1">
                    <span className="m-0 text-bold memberName text-red">
                      {" "}
                      {item.orderId}
                    </span>
                    <span className="">
                      <span className="text-custom-4 mt-1 small  text-bold">
                        {item.checkoutType === "Online Payment"
                          ? item.checkoutType
                          : item.checkoutType + " Checkout"}
                      </span>
                    </span>
                  </div>
                </div>
              </Card.Title>

              <div className="card-tools endColumn">
                <div className="   mt-xl-2 mt-lg-2 mt-md-2 pt-xl-1 pt-lg-1 pt-md-1">
                  {(item.orderStatus === "0" || item.orderStatus === 0) && (
                    <span className="badge badge-warning me-1 text-dark">
                      Processing
                    </span>
                  )}
                  {(item.orderStatus === "1" || item.orderStatus === 1) && (
                    <span className="badge badge-success me-1 text-white">
                      Completed
                    </span>
                  )}
                  {(item.orderStatus === "2" || item.orderStatus === 2) && (
                    <span className="badge badge-danger me-1 text-white">
                      Cancelled
                    </span>
                  )}

                  {item.createdAt && (
                    <span className="badge badge-light me-1 text-dark">
                      Order Submission Date :{" "}
                      <span className="text-secondary">
                        <ModuleDisplayDate value={item.createdAt} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>

            <Card.Body className="p-2">
              {/* Admin/Cancellation Section */}
              {item.adminComments && (
                <Alert className="alert-custom-2 d-flex mb-1  flex-wrap p-1 font-small">
                  <strong className="me-1 mt-1 text-custom-1">
                    Admin Comments:
                  </strong>
                  <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                    <span className="font-small text-normal text-custom-1 html">
                      {item.adminComments}
                    </span>
                  </div>
                </Alert>
              )}

              {/* Details Grid */}
              <Row className="g-2">
                {(item.shippingAddress || item.customer) && (
                  <Col xl={4} lg={6} md={12}>
                    <Card
                      className="border-0 shadow-sm hover:shadow-md transition-shadow"
                      style={{ backgroundColor: COLORS.lightGray }}
                    >
                      <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                        <h6 className="text-md text-white mb-0 fw-bold">
                          Customer
                        </h6>
                      </Card.Header>

                      <Card.Body className="pt-3 pb-2 px-3 rounded-bottom">
                        {/* CUSTOMER DETAILS */}
                        {item.customer && (
                          <div className=" pb-2 ">
                            {/* <h6
                              className="fw-bold mb-2"
                              style={{ color: COLORS.secondary }}
                            >
                              Customer Details
                            </h6> */}

                            <div className="d-flex align-items-center gap-2 px-2 mt-2">
                              {/* Avatar / Icon */}
                              {item?.checkoutType?.toLowerCase() ===
                              "member" ? (
                                <Link
                                  to={`/customers/${item.customer._id}`}
                                  className="text-decoration-none flex-shrink-0"
                                  style={{ color: COLORS.primary }}
                                >
                                  <i className="fas fa-user text-xl me-3 text-custom-2"></i>
                                </Link>
                              ) : (
                                <div
                                  className="text-decoration-none flex-shrink-0"
                                  style={{ color: COLORS.primary }}
                                >
                                  <i className="fas fa-user text-xl me-3 text-custom-2"></i>
                                </div>
                              )}

                              {/* Customer Info */}
                              <div>
                                {item?.checkoutType?.toLowerCase() ===
                                "member" ? (
                                  <Link
                                    to={`/customers/${item.customer._id}`}
                                    className="text-decoration-none"
                                  >
                                    <p className="fw-bold mb-0 text-custom-2">
                                      {item.customer.fullName}
                                    </p>
                                  </Link>
                                ) : (
                                  <div className="text-decoration-none">
                                    <p className="fw-bold mb-0 text-custom-2">
                                      {item.customer.fullName}
                                    </p>
                                  </div>
                                )}

                                {item.customer.email && (
                                  <p className="text-sm mb-1 opacity-75">
                                    <ModuleDisplayEmail
                                      value={item.customer.email}
                                    />
                                  </p>
                                )}

                                {item.customer.phone && (
                                  <p className="text-sm mb-0 opacity-75">
                                    <ModuleDisplayPhone
                                      value={item.customer.phone}
                                    />
                                  </p>
                                )}

                                {item.customer.country && (
                                  <p className="text-sm mb-0 text-secondary opacity-80">
                                    {item.customer.country}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                    <Card
                      className="border-0 shadow-sm hover:shadow-md transition-shadow"
                      style={{ backgroundColor: COLORS.lightGray }}
                    >
                      <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                        <h6 className="text-md text-white mb-0 fw-bold">
                          Shipping
                        </h6>
                      </Card.Header>

                      <Card.Body className="pt-3 pb-2 px-3 rounded-bottom">
                        {item.shippingAddress && (
                          <div>
                            {/* <h6
                              className="fw-bold mb-2"
                              style={{ color: COLORS.secondary }}
                            >
                              Shipping Details
                            </h6> */}

                            <p className="text-md fw-bold mb-1">
                              {item.shippingAddress.firstName}{" "}
                              {item.shippingAddress.lastName}
                            </p>

                            {item.shippingAddress.email && (
                              <p className="text-sm mb-1 opacity-80">
                                <ModuleDisplayEmail
                                  value={item.shippingAddress.email}
                                />
                              </p>
                            )}

                            {item.shippingAddress.phone && (
                              <p className="text-sm mb-2 opacity-80">
                                <ModuleDisplayPhone
                                  value={item.shippingAddress.phone}
                                />
                              </p>
                            )}

                            {(item.shippingAddress.addressLine1 ||
                              item.shippingAddress.addressLine2 ||
                              item.shippingAddress.area ||
                              item.shippingAddress.landmark ||
                              item.shippingAddress.city ||
                              item.shippingAddress.state ||
                              item.shippingAddress.country) && (
                              <div>
                                <p
                                  className="text-sm text-secondary mb-0"
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  {[
                                    item.shippingAddress.addressLine1,
                                    item.shippingAddress.addressLine2,
                                    item.shippingAddress.area,
                                    item.shippingAddress.landmark,
                                    item.shippingAddress.city,
                                    item.shippingAddress.state,
                                    item.shippingAddress.country,
                                  ]
                                    .filter(Boolean)
                                    .join(", ")}
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                )}

                {item.payment && (
                  <Col xl={8} lg={8} md={12}>
                    <Link
                      to={`/payments/${item.payment._id}`}
                      className="w-full"
                      title="Click to view payment details"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <Card
                        className="border-0 shadow-sm hover:shadow-md transition-shadow"
                        style={{
                          backgroundColor: COLORS.lightGray,
                        }}
                      >
                        <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                          <h6 className="text-md text-white mb-0 fw-bold">
                            Payment Details
                          </h6>
                        </Card.Header>

                        <Card.Body className="pt-3 pb-3 px-3 rounded-bottom d-flex flex-column flex-md-row justify-content-between gap-3">
                          {/* LEFT — Payment Info */}
                          <div className="flex-grow-1">
                            {/* Status */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <span className="fw-semibold text-secondary">
                                Status
                              </span>
                              <Badge
                                bg={
                                  item.payment.status === "1"
                                    ? "success"
                                    : "warning"
                                }
                                text="dark"
                                className="rounded-pill px-3 py-1"
                                style={{
                                  backgroundColor:
                                    item.payment.status === "1"
                                      ? "rgba(25,135,84,0.15)"
                                      : "rgba(255,193,7,0.2)",
                                  color:
                                    item.payment.status === "1"
                                      ? "#198754"
                                      : "#b58900",
                                  fontWeight: 600,
                                }}
                              >
                                {item.payment.status === "1"
                                  ? "Paid"
                                  : "Pending"}
                              </Badge>
                            </div>

                            {/* Transaction ID */}
                            {item.payment.transactionId && (
                              <div className="d-flex justify-content-between mb-2">
                                <span className="fw-semibold text-secondary">
                                  Transaction ID
                                </span>
                                <span className="fw-bold text-dark text-end">
                                  {item.payment.transactionId}
                                </span>
                              </div>
                            )}
                            {item?.payment?.stripePaymentId && (
                              <div className="d-flex justify-content-between mb-2">
                                <span className="fw-semibold text-secondary">
                                  Stripe Payment ID
                                </span>
                                <span className="fw-bold text-dark text-end">
                                  {item.payment.stripePaymentId}
                                </span>
                              </div>
                            )}
                            {/* Payment Date */}
                            {item.payment.date && (
                              <div className="d-flex justify-content-between mb-2">
                                <span className="fw-semibold text-secondary">
                                  Date
                                </span>
                                <span className="text-dark text-end">
                                  <ModuleDisplayDate
                                    value={item.payment.date}
                                  />
                                </span>
                              </div>
                            )}
                            {item.appliedCouponId && (
                              <div className="d-flex justify-content-between mb-2">
                                <span className="fw-semibold text-secondary">
                                  Coupon Applied
                                </span>
                                <span className="text-custom-3 text-bold text-end">
                                  {item.appliedCoupon?.couponCode || (
                                    <BsCheckCircleFill className="text-success" />
                                  )}
                                </span>
                              </div>
                            )}
                          </div>

                          {/* RIGHT — Amount Breakdown */}
                          <div className="flex-grow-1 border-top border-light pt-3 pt-md-0 border-md-0 ps-md-4">
                            <div className="d-grid gap-2">
                              {/* Subtotal Before Discount */}
                              {item.subTotalBeforeDiscount &&
                                item.discountAmount > 0 && (
                                  <div className="d-flex justify-content-between">
                                    <span className="text-secondary">
                                      Subtotal (Before Discount)
                                    </span>
                                    <span className="fw-bold">
                                      {item.subTotalBeforeDiscount}{" "}
                                      {getCurrencyCode()}
                                    </span>
                                  </div>
                                )}

                              {/* Discount */}
                              {item.discountAmount > 0 && (
                                <div className="d-flex justify-content-between">
                                  <span className="text-secondary">
                                    Discount
                                  </span>
                                  <span className="fw-bold">
                                    -{item.discountAmount} {getCurrencyCode()}
                                  </span>
                                </div>
                              )}

                              {/* Subtotal */}
                              {item.payment.subTotal && (
                                <div className="d-flex justify-content-between">
                                  <span className="text-secondary">
                                    Subtotal{" "}
                                    {item.discountAmount > 0 && (
                                      <span>(After Discount)</span>
                                    )}
                                  </span>
                                  <span className="fw-bold">
                                    {item.payment.subTotal} {getCurrencyCode()}
                                  </span>
                                </div>
                              )}

                              {/* Applied Coupon */}
                              {/* {item.payment.appliedCouponId && (
                                <div className="d-flex justify-content-between text-success">
                                  <span className="text-secondary">
                                    Coupon Applied
                                  </span>
                                  <span className="fw-bold">
                                    -{item.payment.discountAmount}{" "}
                                    {getCurrencyCode()}
                                  </span>
                                </div>
                              )} */}

                              {/* VAT */}
                              {item.payment.vatAmount && (
                                <div className="d-flex justify-content-between">
                                  <span className="text-secondary">VAT</span>
                                  <span className="fw-bold">
                                    {item.payment.vatAmount} {getCurrencyCode()}
                                  </span>
                                </div>
                              )}

                              {/* Shipping */}
                              {item.payment.shippingCharges && (
                                <div className="d-flex justify-content-between">
                                  <span className="text-secondary">
                                    Shipping
                                  </span>
                                  <span className="fw-bold">
                                    {item.payment.shippingCharges}{" "}
                                    {getCurrencyCode()}
                                  </span>
                                </div>
                              )}

                              {/* Total */}
                              <div className="d-flex justify-content-between border-top pt-2 mt-2">
                                <span className="fw-semibold text-dark">
                                  Total
                                </span>
                                <span
                                  className="fw-bold"
                                  style={{
                                    color:
                                      item.payment.status === "1"
                                        ? "#198754"
                                        : "#b58900",
                                  }}
                                >
                                  {item.payment.totalAmount} {getCurrencyCode()}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                )}
              </Row>

              {/* Ordered Items Grid */}
              {item.orderedItems?.length > 0 && (
                <>
                  <Card
                    className="border-0 shadow-sm"
                    style={{ backgroundColor: COLORS.lightGray }}
                  >
                    <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                      <h6
                        className="text-md text-bold text-white mb-0"
                        style={{ color: COLORS.text }}
                      >
                        Ordered Items ({item.orderedItems.length})
                      </h6>
                    </Card.Header>

                    <Card.Body className="p-0">
                      <Table
                        responsive
                        hover
                        className="align-middle text-center mb-0"
                        style={{
                          borderColor: "#dcdcdc",
                          backgroundColor: COLORS.lightGray,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "120px" }}>Image</th>
                            <th
                              style={{ width: "50%" }}
                              className="text-center"
                            >
                              Name
                            </th>
                            <th>Quantity</th>
                            <th>Price</th>
                          </tr>
                        </thead>

                        <tbody>
                          {item.orderedItems.map(
                            (order, index) =>
                              order.product && (
                                <tr key={index}>
                                  <td className="p-2">
                                    <div
                                      style={{
                                        width: 50,
                                        height: 50,
                                        overflow: "hidden",
                                        margin: "0 auto",
                                        borderRadius: 8,
                                      }}
                                    >
                                      <ReactFancyBox
                                        thumbnail={`${process.env.REACT_APP_BACKEND_URL}public/${order.product.image}`}
                                        image={`${process.env.REACT_APP_BACKEND_URL}public/${order.product.image}`}
                                        caption={order.product.title}
                                      />
                                    </div>
                                  </td>

                                  <td className="text-start">
                                    <Link
                                      to={`/products/${order.product._id}`}
                                      className="text-decoration-none fw-semibold text-custom-2  text-sm"
                                    >
                                      {order.product.title}
                                    </Link>

                                    {order.product.categories?.length > 0 && (
                                      <div className="text-muted small mt-1">
                                        {order.product.categories.join(", ")}
                                      </div>
                                    )}
                                  </td>

                                  <td className="fw-semibold">
                                    {order.quantity}
                                  </td>

                                  <td className="fw-semibold text-success">
                                    {order.price} {getCurrencyCode()}
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </Table>
                    </Card.Body>
                  </Card>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
